export default {
  slug: "root-canal-treatment-in-guwahati",
  title: "Root Canal Treatment (RCT) in Guwahati",
  subtitle: "Say goodbye to tooth pain with safe, gentle, and advanced root canal treatment by trusted dental experts",
  heroImage: "/dental-services/root-canal-treatment/root-canal-treatment-in-guwahati.webp",
  

  sections: [
    {
      type: "text",
      heading: "Root Canal Treatment in Guwahati",
      content: `
Root Canal Treatment (RCT) is a dental procedure used to save a severely infected or damaged tooth. When the inner pulp of the tooth becomes infected due to deep cavities, cracks, or trauma, a root canal is required to remove the infection and prevent tooth loss.

At our clinic, we provide safe, gentle, and painless root canal treatment to relieve pain, restore tooth function, and preserve your natural smile.
      `,
    },

    {
      type: "text",
      heading: "What Is Root Canal Treatment?",
      content: `
A root canal treatment involves removing the infected or inflamed pulp (soft tissue inside the tooth), cleaning and disinfecting the canals, and sealing them to prevent future infection. The tooth is then restored with a filling or crown for strength and protection.

RCT helps to:
✔ Relieve tooth pain  
✔ Remove infection  
✔ Prevent tooth extraction  
✔ Restore chewing ability  
✔ Save your natural tooth
      `,
    },
    {
      type: "image",
      images: [
        "/dental-services/root-canal-treatment.webp",
        "/dental-services/root-canal-treatment/rct-in-guwahati.webp",
        "/dental-services/root-canal-treatment/rct-in-vip-road.webp"
      ],
      caption: "Images are for illustrative purposes only",
    },

    {
      type: "text",
      heading: "When Do You Need a Root Canal?",
      content: `
A dentist can clinically examine and confirm whether you need a root canal. However, you should visit a dentist immediately if you experience:

• Severe or persistent tooth pain  
• Sensitivity to hot or cold that lasts long  
• Swelling in gums or face  
• Pimple-like bump on gums  
• Pain while chewing or biting  
• Darkening of the tooth  
• Bad taste or pus discharge  

Ignoring these symptoms can lead to abscess formation and serious complications.
      `,
    },

    {
      type: "text",
      heading: "Root Canal Treatment Procedure",
      content: `
Root canal treatment is usually completed in 1–2 visits and involves the
following steps:

1. Clinical examination and X-ray  
2. Local anesthesia to numb the area  
3. Removal of infected pulp  
4. Cleaning and shaping of canals  
5. Disinfection  
6. Sealing the canals  
7. Final restoration with filling followed by crown

The procedure is comfortable, painless, and highly effective.
      `,
    },

    {
      type: "text",
      heading: "Benefits of Root Canal Treatment",
      content: `
• Saves your natural tooth  
• Eliminates infection  
• Relieves pain and sensitivity  
• Restores tooth function  
• Prevents spread of bacteria  
• Improves overall oral health
      `,
    },

    {
      type: "text",
      heading: "What Happens After a Root Canal?",
      content: `
After RCT, the tooth becomes infection-free but slightly brittle. That’s why dentists often recommend a dental crown for long-term strength and protection.
      `,
    },

    {
      type: "text",
      heading: "How Long Does a Root Canal-Treated Tooth Last?",
      content: `
With proper oral care and a dental crown, a root canal-treated tooth can last many years or even a lifetime.
      `,
    },

    {
      type: "text",
      heading: "Why Choose Us for Root Canal Treatment?",
      content: `
✔ Experienced dentists  
✔ Advanced equipment  
✔ Painless procedures  
✔ Strict sterilization and hygiene measures  
✔ Long-lasting results  
✔ Affordable treatment plans
      `,
    },
  ],

  faqs: [
    {
      q: "Is RCT painful?",
      a: "No. With modern anesthesia and advanced techniques, root canal treatment is almost painless. Most patients feel relief after the procedure.",
    },
    {
      q: "Is RCT better than tooth extraction?",
      a: "Yes. Saving your natural tooth is always better than removing it. RCT preserves your bite and jawbone.",
    },
    {
      q: "How long does RCT take?",
      a: "Usually 40–60 minutes per visit, depending on the tooth condition and severity of infection.",
    },
    {
      q: "Can I eat after a root canal?",
      a: "You should avoid eating until the numbness wears off. Soft foods are recommended for the first day.",
    },
    {
      q: "Do I need a crown after RCT?",
      a: "Yes. After RCT, the tooth becomes slightly brittle. A dental crown is recommended—especially for back teeth—to prevent fractures.",
    },
    {
      q: "Is RCT safe?",
      a: "Yes. Root canal treatment is a safe and commonly performed dental procedure.",
    },
  ],

  cta: {
    heading: "Book Your Root Canal Consultation",
    buttonText: "Book RCT Appointment",
    link: "/book-appointment-dental-clinic-guwahati",
    description: `
If you’re experiencing tooth pain or signs of infection, don’t wait.
Early treatment can save your tooth and prevent complications.

For pricing details, please call us or walk in for a dental consultation.
📍 Location: First Floor, Global Tower, Near Mangalam Grand, Pathar Quarry, VIP Road, Guwahati, Assam

📞 Call at 8638940021 to book your appointment

🦷 Your comfort. Your smile. Our priority.
    `,
  },
};
